(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-singles/assets/javascripts/coupon-choice/single-coupon-xpert.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-singles/assets/javascripts/coupon-choice/single-coupon-xpert.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useContext = _React.useContext,
  useEffect = _React.useEffect;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const XPERT_WAGER_SROW = svs.components.tipsen.engine.constants.xpertWagerSystemTypes.XPERT_WAGER_SROW;
const DrawContext = svs.components.tipsen.drawProvider.DrawContext;
const _svs$components$tipse = svs.components.tipsen.engine.selectors.couponSelectors,
  selectHasBoardUserSigns = _svs$components$tipse.selectHasBoardUserSigns,
  selectXpertAnalysisAuthorId = _svs$components$tipse.selectXpertAnalysisAuthorId,
  selectNumberOfBoards = _svs$components$tipse.selectNumberOfBoards,
  selectBoardUserSigns = _svs$components$tipse.selectBoardUserSigns,
  selectPixSizeSingleRow = _svs$components$tipse.selectPixSizeSingleRow;
const _svs$ui = svs.ui,
  reactForm = _svs$ui.reactForm,
  ReactButton = _svs$ui.ReactButton;
const Fieldset = reactForm.Fieldset,
  RadioButton = reactForm.RadioButton,
  RadioGroup = reactForm.RadioGroup;
const useAnalyses = svs.components.sportinfo.gameAnalysesRedux.hooks.useAnalyses;
const useIsCurrentDrawPlayable = svs.components.tipsen.hooks.useIsCurrentDrawPlayable;
const useGenerateSportPixCouponAction = svs.components.tipsen.engine.utils.helpers.useGenerateSportPixCouponAction;
const BASEROW_EMPTY = 'BASEROW_EMPTY';
const BASEROW_USER_SIGNS = 'BASEROW_USER_SIGNS';
const SingleCouponXpertButton = _ref => {
  let selectedBoardIndex = _ref.selectedBoardIndex,
    onClick = _ref.onClick,
    boardIndex = _ref.boardIndex,
    disabled = _ref.disabled;
  const numRows = boardIndex + 1;
  const buttonTitle = numRows === 1 ? '1 Rad' : "".concat(numRows, " Rader");
  const isSelected = selectedBoardIndex === boardIndex;
  return React.createElement(ReactButton, {
    "aria-checked": isSelected,
    checked: isSelected,
    className: "tipsen-pix-system-selector-button f-bold",
    disabled: disabled,
    inverted: isSelected,
    onClick: onClick,
    role: "radio",
    thin: true,
    transparent: !isSelected
  }, React.createElement("span", {
    className: "f-200"
  }, buttonTitle));
};
const SingleCouponXpert = _ref2 => {
  let couponId = _ref2.couponId;
  const generateSportPixCoupon = useGenerateSportPixCouponAction();
  const isDrawPlayable = useIsCurrentDrawPlayable();
  const nrOfPixBoards = useSelector(state => selectPixSizeSingleRow(state, couponId));
  const _useState = useState(nrOfPixBoards > 0 ? nrOfPixBoards - 1 : 0),
    _useState2 = _slicedToArray(_useState, 2),
    selectedPixSystem = _useState2[0],
    setSelectedPixSystem = _useState2[1];
  const _useContext = useContext(DrawContext),
    productId = _useContext.productId,
    drawNumber = _useContext.drawNumber;
  const boardSize = useSelector(state => selectNumberOfBoards(state, couponId));
  const dispatch = useDispatch();
  const hasUserSigns = useSelector(state => selectHasBoardUserSigns(state, couponId, 0));
  const userSigns = useSelector(state => selectBoardUserSigns(state, couponId, 0));
  const xpertAnalysisAuthorId = useSelector(state => selectXpertAnalysisAuthorId(state, couponId));
  const _useState3 = useState(() => {
      if (hasUserSigns) {
        return BASEROW_USER_SIGNS;
      } else if (xpertAnalysisAuthorId) {
        return xpertAnalysisAuthorId;
      }
      return BASEROW_EMPTY;
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    baseRow = _useState4[0],
    setBaseRow = _useState4[1];
  const _useAnalyses = useAnalyses(productId, drawNumber),
    baseRows = _useAnalyses.baseRows;
  useEffect(() => {
    if (!hasUserSigns && baseRow === BASEROW_USER_SIGNS) {
      setBaseRow(BASEROW_EMPTY);
    }
  }, [hasUserSigns, setBaseRow, baseRow]);
  const onGeneratePixRows = (boardIndex, _baseRow) => {
    const numRows = boardIndex + 1;
    const dispatchAction = () => {
      let options = {
        productId,
        system: 1,
        numRows,
        drawNumber,
        couponId,
        baseRow: [],
        type: XPERT_WAGER_SROW,
        keepUserSigns: false
      };
      if (_baseRow === BASEROW_USER_SIGNS) {
        options = _objectSpread(_objectSpread({}, options), {}, {
          baseRow: userSigns,
          keepUserSigns: true
        });
      } else if (_baseRow !== BASEROW_EMPTY) {
        options = _objectSpread(_objectSpread({}, options), {}, {
          baseRow: baseRows[_baseRow],
          xpertAnalysisAuthorId: baseRow
        });
      }
      dispatch(generateSportPixCoupon({
        data: options
      }));
    };
    if (hasUserSigns && baseRow !== BASEROW_USER_SIGNS) {
      svs.components.dialog.api.add(new svs.components.dialog.Confirm({
        actions: [{
          title: 'Avbryt'
        }, {
          callback() {
            svs.components.dialog.api.close();
            dispatchAction();
          },
          title: 'Fortsätt'
        }],
        message: [{
          text: 'Vill du fortsätta ändå?',
          type: svs.components.dialog.message.TEXT
        }],
        branding: svs.components.dialog.branding.SPORT,
        icon: 'dustbin',
        title: 'Dina tecken kommer att rensas'
      }));
    } else {
      dispatchAction();
    }
  };
  const pixButtons = [];
  for (let boardIndex = 0; boardIndex < boardSize; boardIndex++) {
    pixButtons.push(React.createElement(SingleCouponXpertButton, {
      boardIndex: boardIndex,
      disabled: !isDrawPlayable,
      key: boardIndex,
      onClick: () => {
        setSelectedPixSystem(boardIndex);
        onGeneratePixRows(boardIndex, baseRow);
      },
      selectedBoardIndex: selectedPixSystem
    }));
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "f-550 tipsen-pix-selector-header-txt"
  }, "Utg\xE5 ifr\xE5n"), React.createElement(Fieldset, {
    className: "xpert-choices",
    legend: "V\xE4lj tecken att utg\xE5 ifr\xE5n",
    srOnly: true
  }, React.createElement(RadioGroup, {
    className: "two-col",
    size: "200",
    thin: true
  }, React.createElement(RadioButton, {
    checked: baseRow === BASEROW_EMPTY,
    inline: true,
    name: "xpert-choice",
    onChange: event => {
      setBaseRow(event);
    },
    value: BASEROW_EMPTY
  }, "Grunden"), React.createElement(RadioButton, {
    checked: baseRow === BASEROW_USER_SIGNS,
    disabled: !hasUserSigns,
    inline: true,
    name: "xpert-choice",
    onChange: event => {
      setBaseRow(event);
    },
    value: BASEROW_USER_SIGNS
  }, "Egna val"))), React.createElement("div", {
    className: "tipsen-pix-selector-grid-singel-row"
  }, pixButtons));
};
setGlobal('svs.components.tipsen.routePlaySingles.SingleCouponXpert', SingleCouponXpert);

 })(window);